(()=>{
'use strict';
/* Old-ring confidence gate for the size finder. Unchanged rule: a flattened, swollen or broken ring (level 5), or a
   used / unknown ring (level 3), blocks direct ordering: the result list is hidden and the panel offers a review.
   WP2 2026-10-03: the panel is shown only when ordering is held back (no "confidence level" banner on normal
   searches), copy is plain language, markup uses ic-* classes. An incomplete size without a ring condition is
   no longer gated: the finder itself handles ID-only or CS-only searches. */
const LEVELS={
  1:['Size matches the catalogue','Check material, hardness and the application before ordering.'],
  2:['Size found, one check left','Check the specification before ordering.'],
  3:['Confirm the size before you order','A used ring can be stretched or worn, so the measured size may not be its original size. Direct ordering is held back until the size is confirmed.'],
  4:['Enter both ID and CS','With a ring condition set we need both the inside diameter and the cross-section. Remeasure, or send us the ring details for review.'],
  5:['Do not pick a replacement from these numbers alone','A flattened, swollen or broken ring has changed shape, so its ID and CS no longer show the original size. Send us the details for review, or measure the groove instead.']
};
const unsafe=new Set(['flattened','swollen','broken']);
const positive=v=>/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(String(v||'').trim())&&Number(v)>0;
const fmt=n=>String(Number(Number(n).toFixed(5)));
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const track=(event,detail)=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event},detail||{}));};
function init(root){
  if(root.dataset.confidenceReady)return;root.dataset.confidenceReady='true';
  const form=root.querySelector('[data-finder-form]'),panel=root.querySelector('[data-confidence-panel]'),out=root.querySelector('[data-finder-results]');
  if(!form||!panel||!out)return;
  const cond=root.querySelector('[data-fd-cond]');
  const field=n=>form.elements[n],unit=()=>field('units')?.value||'mm';
  const mm=n=>positive(field(n)?.value)?Number(field(n).value)*(unit()==='in'?25.4:1):null;
  function sizeState(){
    const id=mm('id'),cs=mm('cs');
    return{id,cs,count:[id,cs].filter(v=>v!==null).length,complete:id!==null&&cs!==null};
  }
  function assess(){
    const s=sizeState(),c=field('condition')?.value||'',sku=String(field('sku')?.value||'').trim();
    const standard=field('standard')?.value||'',code=String(field('standard_code')?.value||'').trim();
    const hasStd=(standard==='AS568'||standard==='ISO3601')&&code;
    if(!s.count&&!c&&!sku&&!hasStd)return null;
    if(unsafe.has(c))return{level:5,blocked:true,state:s};
    if(sku)return{level:2,blocked:false,state:s};
    const ready=()=>out.dataset.state==='ready'&&out.querySelector('a[href^="/products/"]');
    if(hasStd)return{level:ready()?1:2,blocked:false,state:s};
    if(s.complete){
      if(!c||c==='new')return{level:ready()?1:2,blocked:false,state:s};
      if(c==='used'||c==='unknown')return{level:3,blocked:true,state:s};
    }
    if(!c)return null;
    return{level:4,blocked:true,state:s};
  }
  function reviewUrl(level){
    const p=new URLSearchParams({source:'vnext_finder',request_mode:'APPLICATION_REVIEW',confidence_level:String(level)});
    ['id','cs','material','hardness','sku','standard','standard_code','condition'].forEach(k=>{const v=String(field(k)?.value||'').trim();if(v)p.set(k,v)});
    if(unit()==='in'){
      ['id','cs'].forEach(k=>{const v=mm(k);if(v!==null){p.set(k,fmt(v));p.set('original_'+k,String(field(k).value));}});
      p.set('original_unit','in');p.set('unit','mm');
    }
    const s=sizeState();if(s.complete)p.set('size_or_sku',s.id.toFixed(2)+' x '+s.cs.toFixed(2)+' mm');
    return'/pages/bulk-quote?'+p.toString();
  }
  function actions(a){
    const links=[`<a class="ic-btn ic-btn--dark ic-btn--sm" href="${esc(reviewUrl(a.level))}">Ask us to review</a>`];
    if(field('condition')?.value==='swollen')links.push('<a class="ic-btn ic-btn--ghost ic-btn--sm" href="/pages/chemical-compatibility">Chemical compatibility</a>');
    links.push('<a class="ic-btn ic-btn--ghost ic-btn--sm" href="/pages/size-guide?view=measure&amp;source=finder">Measure again</a>');
    links.push('<a class="ic-btn ic-btn--ghost ic-btn--sm" href="/pages/size-guide?view=oxx-groove-design&amp;source=finder">Measure the groove</a>');
    return`<div class="ic-fd-conf__acts">${links.join('')}</div>`;
  }
  function render(a){
    if(cond)cond.toggleAttribute('data-set',Boolean(field('condition')?.value));
    if(!a||!a.blocked){
      panel.hidden=true;panel.replaceChildren();
      if(a)root.dataset.confidenceBlocked='false';else delete root.dataset.confidenceBlocked;
      return;
    }
    const [title,desc]=LEVELS[a.level];panel.hidden=false;panel.dataset.level=String(a.level);
    root.dataset.confidenceBlocked='true';
    panel.innerHTML=`<div class="ic-fd-conf__ic"></div><div class="ic-fd-conf__body"><p class="ic-eyebrow">Ordering held back</p><h2 class="ic-h3">${title}</h2><p>${desc}</p>${actions(a)}</div>`;
    const t=root.querySelector('template[data-fd-icons]'),i=t&&t.content.querySelector('[data-i="alert"] svg');
    if(i)panel.querySelector('.ic-fd-conf__ic').append(i.cloneNode(true));
  }
  function appendContext(a){
    if(!a)return;
    root.querySelectorAll('a[href*="/pages/bulk-quote"]').forEach(link=>{
      try{const u=new URL(link.href,location.origin),c=field('condition')?.value||'';if(c)u.searchParams.set('condition',c);u.searchParams.set('confidence_level',String(a.level));link.href=u.pathname+u.search;}catch(_){ }
    });
  }
  let last='';
  function sync(){const a=assess();const key=a?a.level+':'+a.blocked+':'+(field('condition')?.value||''):'';if(key!==last||(a&&a.blocked)){last=key;render(a);}appendContext(a);return a;}
  root.addEventListener('input',e=>{if(['id','cs'].includes(e.target?.name))sync();},true);
  root.addEventListener('change',e=>{
    if(e.target?.name==='condition'){const a=sync();if(a?.blocked)e.stopImmediatePropagation();return;}
    setTimeout(sync,0);
  },true);
  form.addEventListener('submit',e=>{
    const a=sync();
    if(a?.blocked){
      track('oxx_finder_review_required',{confidence_level:a.level,condition:String(field('condition')?.value||''),has_size:Boolean(a.state&&a.state.complete)});
      e.preventDefault();e.stopImmediatePropagation();
      const d=root.querySelector('[data-finder-filter-dialog]');if(d?.open)d.close();
      panel.scrollIntoView({behavior:'smooth',block:'nearest'});
    }
  },true);
  form.addEventListener('reset',()=>setTimeout(()=>{last='';render(null);},0),true);
  const observer=new MutationObserver(()=>{const a=sync();appendContext(a);});
  observer.observe(out,{childList:true,subtree:true,attributes:true,attributeFilter:['data-state']});
  sync();
}
const boot=()=>document.querySelectorAll('[data-size-confidence]').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();
